import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import SyncIcon from '@material-ui/icons/Sync';
import CircularProgress from '@material-ui/core/CircularProgress';
import {getError } from '../common/getError'
import Tooltip from '@material-ui/core/Tooltip';
import {orderBy } from '../common/orderby'

export class WorkersEditor extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  
constructor(props)
{
  console.log({c: "construct", props});
  super(props);
}

  render() {
    console.log({props: this});
    if (!this.props.home)
     return "no props";
    return (
      <div className="home-workers-editor">
                <Paper style={{margin:"12px", padding:"12px"}}>
        
        <div>
          <h2>Team-Mitglieder</h2>
          <div><Button 
            onClick={() => {this.props.actions.syncWorkersWithPco()}}
            variant="outlined" 
            color="primary">{this.props.home.syncWorkersWithPcoPending ? <CircularProgress size={24}  /> : <SyncIcon />}&nbsp;Aktualisieren</Button></div>

    {[...new Set(Object.values(this.props.home.workers).map(w => w.status))].map(status =>{ let workers = Object.values(this.props.home.workers).filter(w => w.status === status); return <div><Tooltip title={orderBy(workers.map(w => w.name),x=>x).join(", ")}><span>{workers.length + "x " + (status || "(ungültiger Status)")}</span></Tooltip></div>} )}
          <br />
          {this.props.home.syncWorkersWithPcoError && getError(this.props.home.syncWorkersWithPcoError) }
          <div><pre>{this.props.home.syncWorkersWithPcoMessages}</pre></div>
        </div>
        </Paper>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkersEditor);



// WEBPACK FOOTER //
// ./src/features/home/WorkersEditor.js